import { useCallback, useEffect, useRef, useState } from 'react'

/** Tiny data-loading hook: { data, error, loading, reload }. Keeps pages free of fetch boilerplate. */
export function useAsync<T>(fn: () => Promise<T>, deps: unknown[] = []) {
  const generation = useRef(0)
  const [data, setData] = useState<T | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const reload = useCallback(() => {
    const current = ++generation.current
    setLoading(true); setError(null)
    fn().then(value => { if (current === generation.current) setData(value) })
      .catch(e => { if (current === generation.current) setError((e as Error).message) })
      .finally(() => { if (current === generation.current) setLoading(false) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
  useEffect(() => { reload(); return () => { generation.current++ } }, [reload])
  return { data, setData, error, loading, reload }
}
